import styled from 'styled-components';

export const StyledWrapper = styled.div<{ $level: number }>`
  margin-top: 0.5rem;
  padding-left: ${({ $level }) => $level + 1 + 1.25}rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;
